export default [
  {
    icon: "mdi-gauge",
    title: "Dashboards",
    to: { name: "Dashboards" }
  },
  {
    icon: "mdi-account",
    title: "Users",
    to: { name: "Users" }
  },
  {
    icon: "mdi-account-multiple",
    title: "Groups",
    to: { name: "Groups" }
  },
  {
    icon: "mdi-cast",
    title: "Live Events",
    to: { name: "Events" }
  },
  {
    icon: "mdi-video",
    title: "Contents",
    to: { name: "Contents" }
  },
  {
    icon: "mdi-apps",
    title: "Collections",
    to: { name: "Collections" }
  }
];
